<template>
  <div class="inspect-tasks-details">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="巡检详情" />
    <ml-tip class="scroll-box" :showHeader="false" style="border: 0">
      <el-scrollbar :height="tabberHeight(185)">
        <div class="content-box">
          <el-tabs v-model="activeName" class="demo-tabs">
            <el-tab-pane label="巡检详情" name="detail"></el-tab-pane>
            <el-tab-pane label="点位打卡记录" name="pointCheck"></el-tab-pane>
            <el-tab-pane label="流程进度" name="process"></el-tab-pane>
            <el-tab-pane label="里程信息" name="pec"></el-tab-pane>
          </el-tabs>
          <div v-if="activeName === 'detail'">
            <!-- 表单 -->
            <ml-form disabled labelWidth="200px" style="width: 1200px; margin: 20px auto 40px">
              <!-- 提示标题 -->
              <el-divider content-position="left" style="font-weight: bold"
                >巡检详情信息</el-divider
              >
              <div class="globalTitle inspect-tasks-details-globalTitle">
                巡检详情
                <el-image
                  class="inspect-tasks-details-globalTitle-image"
                  v-if="inspectOrderStatusImg"
                  :src="inspectOrderStatusImg"
                />
              </div>
              <el-row>
                <el-col :span="12">
                  <!-- 所属项目 -->
                  <ml-input
                    prop="projectName"
                    label="所属项目:"
                    placeholder="请输入所属项目"
                    v-model.trim="InspectTasksDetailsForm.projectName"
                  />
                </el-col>
                <el-col :span="12">
                  <!-- 巡检计划 -->
                  <ml-input
                    prop="planName"
                    label="巡检计划:"
                    placeholder="请输入巡检计划"
                    v-model.trim="InspectTasksDetailsForm.planName"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <!-- 计划业务类型 -->
                  <ml-input
                    prop="planBusinessTypeName"
                    label="计划业务类型:"
                    placeholder="请输入计划业务类型"
                    v-model.trim="InspectTasksDetailsForm.planBusinessTypeName"
                  />
                </el-col>
                <el-col :span="12" v-if="InspectTasksDetailsForm.planBusinessType === '1'">
                  <ml-input
                    prop="qualityControlType"
                    label="业务类型:"
                    placeholder="请输入业务类型"
                    v-model.trim="InspectTasksDetailsForm.qualityControlType"
                  />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <!-- 巡检类型 -->
                  <ml-input
                    prop="planType"
                    label="巡检类型:"
                    placeholder="请输入巡检类型"
                    v-model.trim="InspectTasksDetailsForm.planType"
                  />
                </el-col>
                <el-col :span="12">
                  <ml-input
                    prop="taskName"
                    label="巡检名称:"
                    placeholder="请输入巡检名称"
                    v-model.trim="InspectTasksDetailsForm.taskName"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <ml-input
                    prop="startTime"
                    label="预计开始时间:"
                    placeholder="请输入预计开始时间"
                    v-model.trim="InspectTasksDetailsForm.startTime"
                  />
                </el-col>
                <el-col :span="12">
                  <ml-input
                    prop="endTime"
                    label="预计结束时间:"
                    placeholder="请输入预计结束时间"
                    v-model.trim="InspectTasksDetailsForm.endTime"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <ml-input
                    prop="actualStartTime"
                    label="实际开始时间:"
                    placeholder=""
                    v-model.trim="InspectTasksDetailsForm.actualStartTime"
                  />
                </el-col>
                <el-col :span="12">
                  <ml-input
                    prop="endTime"
                    label="实际结束时间:"
                    placeholder=""
                    v-model.trim="InspectTasksDetailsForm.completeTime"
                  />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <ml-input
                    prop="managerUserName"
                    label="负责人:"
                    placeholder="请输入负责人"
                    v-model.trim="InspectTasksDetailsForm.managerUserName"
                  />
                </el-col>
                <el-col :span="12">
                  <ml-input
                    prop="userName"
                    label="执行人:"
                    placeholder="请输入执行人"
                    v-model.trim="InspectTasksDetailsForm.userName"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <!-- 流程 -->
                  <ml-select
                    prop="process.definitionId"
                    placeholder="请选择流程"
                    :options="processData"
                    label="流程:"
                    keyName="definitionId"
                    labelName="processName"
                    valueName="definitionId"
                    v-model="InspectTasksDetailsForm.process.definitionId"
                    :filterable="true"
                    @change="definitionChange"
                  />
                </el-col>
              </el-row>
              <ml-input
                prop="content"
                label="巡检内容:"
                placeholder="请输入巡检内容"
                type="textarea"
                :rows="5"
                v-model.trim="InspectTasksDetailsForm.content"
              />
            </ml-form>

            <ml-form
              labelWidth="200px"
              style="width: 1200px; margin: 20px auto 40px"
              :model="InspectTasksDetailsForm"
            >
              <div class="globalTitle" v-if="InspectTasksDetailsForm.attachVos.length > 0">
                附件
              </div>
              <el-form-item label="附件:" v-if="InspectTasksDetailsForm.attachVos.length > 0">
                <ml-list
                  fileName="fileName"
                  :showDelete="false"
                  :showDown="true"
                  :showPreview="true"
                  :list="InspectTasksDetailsForm.attachVos"
                />
              </el-form-item>
            </ml-form>
          </div>
          <!-- 点位打卡明细台账 + 地图 -->
          <div v-else-if="activeName === 'pointCheck'">
            <div style="width: 1200px; margin: 20px auto 40px">
              <!-- 明细台账表格 -->
              <div class="globalTitle" v-if="pointList.length > 0">点位打卡明细台账</div>
              <el-table :data="pointList" style="width: 100%" v-if="pointList.length > 0">
                <el-table-column
                  align="center"
                  label="规划排序"
                  prop="orderIndex"
                  min-width="10%"
                />
                <el-table-column align="center" label="点位名称" prop="pointName" min-width="15%" />
                <el-table-column align="center" label="打卡时间" min-width="15%">
                  <template #default="scope">
                    <span>{{ scope.row.checkTime || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="打卡经纬度" min-width="15%">
                  <template #default="scope">
                    <span v-if="scope.row.longitude && scope.row.latitude"
                      >{{ scope.row.longitude }},{{ scope.row.latitude }}</span
                    >
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="打卡状态" min-width="12%">
                  <template #default="scope">
                    <span :class="getPointStatusClass(scope.row)">{{
                      getPointStatusText(scope.row)
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="现场照片" min-width="12%">
                  <template #default="scope">
                    <span v-if="scope.row.attachList && scope.row.attachList.length > 0"
                      >{{ scope.row.attachList.length }}张</span
                    >
                    <span v-else>无</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="异常备注" min-width="15%">
                  <template #default="scope">
                    <span>{{ getPointRemark(scope.row) }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <p style="color: #f53f3f; margin-top: 8px" v-if="pointList.length > 0">
                统计：正常打卡{{ pointStats.normal }}个、漏检{{ pointStats.missed }}个、未巡检{{
                  pointStats.notInspected
                }}个
              </p>

              <!-- 地图区域 -->
              <div class="globalTitle" style="margin-top: 30px">巡检点位打卡轨迹</div>
              <div class="point-check-map-wrapper">
                <div id="pointCheckMap" class="point-check-map"></div>
                <!-- 图例 -->
                <div class="point-check-map-legend">
                  <div class="legend-item">
                    <span class="legend-dot legend-dot-plan"></span>
                    <span>配置点位(已打卡)</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-dot legend-dot-not"></span>
                    <span>配置点位(未打卡)</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-dot legend-dot-check"></span>
                    <span>实际打卡位置</span>
                  </div>
                  <!-- <div class="legend-item">
                    <span class="legend-line"></span>
                    <span>驾车轨迹</span>
                  </div> -->
                </div>
              </div>

              <el-empty v-if="pointList.length === 0" description="暂无点位打卡数据"></el-empty>
            </div>
          </div>
          <div v-else-if="activeName === 'process'">
            <div class="globalTitle" v-if="deviceErrorLogsByError.length > 0">流程进度</div>
            <el-form-item v-if="deviceErrorLogsByError.length > 0" style="margin-bottom: 60px">
              <process-schedule-new
                disabled
                v-for="(item, index) in deviceErrorLogsByError"
                :key="item"
                :item="item"
                :state="index === 0"
                type="inspect_task"
                @view-form="viewFromHandle"
              />
            </el-form-item>
          </div>
          <div v-else-if="activeName === 'pec'">
            <div class="globalTitle" v-if="deviceErrorLogsByError.length > 0">里程信息</div>
            <el-table :data="pecList" style="width: 100%">
              <el-table-column align="center" label="车牌号" prop="carNumber" min-width="15%" />
              <el-table-column align="center" label="出发地址" prop="startAddr" min-width="15%" />
              <el-table-column align="center" label="出发地图片" prop="companyName" min-width="15%">
                <template #default="scope">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="`${BASEURL}${FILEPREVIEWURL}/${scope.row.startFileList[0].filePath}`"
                    hide-on-click-modal
                    v-if="scope.row.startFileList[0]"
                    :preview-src-list="[
                      `${BASEURL}${FILEPREVIEWURL}/${scope.row.startFileList[0].filePath}`
                    ]"
                  />
                </template>
              </el-table-column>
              <el-table-column align="center" label="出发时间" prop="createTime" min-width="15%" />
              <el-table-column
                align="center"
                label="目的地地址"
                prop="endAddress"
                min-width="15%"
              />
              <el-table-column align="center" label="目的地图片" prop="companyName" min-width="15%">
                <template #default="scope">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="`${BASEURL}${FILEPREVIEWURL}/${scope.row.endFileList[0].filePath}`"
                    hide-on-click-modal
                    v-if="scope.row.endFileList[0]"
                    :preview-src-list="[
                      `${BASEURL}${FILEPREVIEWURL}/${scope.row.endFileList[0].filePath}`
                    ]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="到达时间"
                prop="endCreateTime"
                min-width="15%"
              />
              <el-table-column align="center" label="乘车人员" prop="endCreateTime" min-width="15%">
                <template #default="scope">
                  <span
                    v-for="item in scope.row.byCarUserVos"
                    :key="item.userId"
                    style="margin-right: 8px"
                    >{{ item.userName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop="companyName" min-width="15%">
                <template #default="scope">
                  <span>{{ scope.row.recordType === 'START' ? '进行中' : '已完成' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="里程数(km)"
                prop="actualMileage"
                min-width="15%"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </el-scrollbar>
    </ml-tip>
    <!-- 处理故障按钮组 -->
    <div class="btn-box">
      <el-button
        v-for="item in customButtons"
        :key="item.value"
        size="medium"
        type="primary"
        @click="clickReportOrder(item)"
      >
        {{ item.name }}
      </el-button>
      <el-button size="medium" icon="el-icon-circle-close" @click="clickCancelFultServiceCenter">
        返回上一页
      </el-button>
      <el-button size="medium" icon="el-icon-download" type="primary" @click="clickDownloadExcel">
        导出
      </el-button>
    </div>
    <!-- 办结提示框 -->
    <!-- 办结 -->
    <completed-dialog
      v-if="showCompletedDialog"
      ref="completedRef"
      :conf="processCof"
      :btnCode="btnCode"
      :btnName="btnName"
      :type="completedType"
      :sourData="sourData"
      :projectId="InspectTasksDetailsForm.projectId"
      busType="inspect_task"
      @close="closeCompletedDialog"
      @success="successCompletedDialog"
    ></completed-dialog>
    <!-- 提交报告 -->
    <submit-task-dialog
      v-if="showSubmitTaskDialog"
      ref="submitTaskRef"
      :conf="processCof"
      :btnCode="btnCode"
      :btnName="btnName"
      :type="submitTaskType"
      :sourData="sourData"
      :inspectTaskId="inspectTaskId"
      :projectId="InspectTasksDetailsForm.projectId"
      busType="inspect_task"
      @close="closeSubmitTaskDialog"
      @success="successSubmitTaskDialog"
    ></submit-task-dialog>
  </div>
</template>

<script>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { tabberHeight, downloadFile } from '@/utils'
import AMapLoader from '@amap/amap-jsapi-loader'
import ProcessScheduleNew from '@components/processScheduleNew.vue'
import submitTaskDialog from '@/components/processDialog/submitTaskDialog'
import completedDialog from '@/components/processDialog/completedDialog'

import { exportInspectById } from '@/API/previewApi'
import { BASEURL, FILEPREVIEWURL } from '@API'
import isAuditImg from '../../assets/image/is-audit.png'
// 待处理
import isDealImg from '../../assets/image/is-deal.png'
// 已办结
import completeImg from '../../assets/image/complete.png'
import { useProcessHandler } from '@/utils/useProcessHandler'

export default {
  name: 'InspectTasksDetails',
  components: {
    ProcessScheduleNew,
    submitTaskDialog,
    completedDialog
  },
  setup() {
    const { dispatch, getters, commit } = useStore()
    const router = useRouter()
    const route = useRoute()
    const { inspectTaskId } = route.query
    const userInfo = computed(() => getters.getUser)

    /* 开始 表单 **********************************/

    // 表单配置
    const InspectTasksDetailsForm = reactive({
      companyId: '',
      inspectTaskId: '',
      projectName: '',
      projectId: '',
      planName: '',
      planType: '',
      taskName: '',
      startTime: '',
      endTime: '',
      managerUserName: '',
      userName: '',
      content: '',
      inspectOrderStatus: '',
      attachVos: [],
      actualStartTime: '',
      completeTime: '',
      inspectUserVos: [],
      qualityControlType: '',
      planBusinessType: '',
      planBusinessTypeName: '',
      process: {
        businessId: '',
        processKey: '',
        definitionId: '',
        procInsId: '',
        businessType: '',
        processName: ''
      }
    })
    const inspectOrderStatusImg = ref()
    watch(
      () => InspectTasksDetailsForm.inspectOrderStatus,
      newvalue => {
        if (newvalue) {
          inspectOrderStatusImg.value =
            newvalue === '2' ? completeImg : newvalue === '1' ? isAuditImg : isDealImg
        }
      }
    )

    const isAudit = (arr = []) => {
      const { userId } = userInfo.value
      const userIdArr = arr ? arr.map(item => item.userId) : []
      return userIdArr.includes(userId)
    }

    const isAmibaManager = row => {
      const { userType, companyId } = userInfo.value
      return userType === 'amiba_manager' && companyId === row.companyId
    }

    // 取消表单
    const clickCancelFultServiceCenter = () => {
      router.go(-1)
      // router.push({ path: '/faultServiceCenter' })
    }
    // 获取单个故障信息
    const getFaultServiceCenterDetails = async () => {
      // 查看故障详情
      await dispatch('fetchGetInspectTask', inspectTaskId).then(data => {
        if (data && data.code === 200 && data.data) {
          Object.keys(InspectTasksDetailsForm).map(item => {
            if (['attachVos'].includes(item)) {
              InspectTasksDetailsForm[item] = data.data[item] || []
            } else {
              InspectTasksDetailsForm[item] = data.data[item]
            }
          })
          InspectTasksDetailsForm['planBusinessTypeName'] =
            InspectTasksDetailsForm.planBusinessType === '1' ? '质检' : '巡检'
          pointList.value = data.data.pointList || []
        }
      })
      // // 查询故障流程进度
      // await dispatch('fetchGetInspectLogsByTask', { inspectTaskId }).then(data => {
      //   if (data && data.code === 200) {
      //     deviceErrorLogsByError.value = data.data
      //   }
      // })
    }

    // 导出 Excel
    const clickDownloadExcel = () => {
      exportInspectById({ id: inspectTaskId })
        .then(res => {
          const disposition = res.headers && res.headers['content-disposition']
          let fileName = `${InspectTasksDetailsForm.taskName || '巡检详情'}.docx`
          if (disposition) {
            const match = disposition.match(/filename=(.+)/)
            if (match) {
              fileName = decodeURIComponent(match[1])
            }
          }
          downloadFile(res.data, fileName)
        })
        .catch(() => {})
    }

    /* 结束 用户表单 **********************************/

    /** 办结 开始***********************************/
    const clickSubmitFultServiceCenter = () => {}
    const updateInfoHandle = async () => {
      // 获取单个故障信息
      await getFaultServiceCenterDetails()
      await getProcessConf(inspectTaskId)
      await getDeviceErrorLogsByError(inspectTaskId)
    }

    /** 流程处理 开始 2024-11-12 ***********************************/
    const {
      btnCode,
      btnName,
      processCof,
      customButtons,
      formDisabled,
      deviceErrorLogsByError,
      showDistributeDialog,
      distributeRef,
      completedType,
      showCompletedDialog,
      completedRef,
      sourData,
      showSubmitDialog,
      submitRef,
      submitType,
      getProcessConf,
      getDeviceErrorLogsByError,
      clickReportOrder,
      successDistributedDialog,
      closeDistributedDialog,
      successCompletedDialog,
      closeCompletedDialog,
      successSubmitDialog,
      closeSubmitDialog,
      viewFromHandle,
      showSubmitTaskDialog,
      submitTaskRef,
      submitTaskType,
      successSubmitTaskDialog,
      closeSubmitTaskDialog
    } = useProcessHandler(dispatch, updateInfoHandle, clickSubmitFultServiceCenter)
    /** 流程处理 结束***********************************/

    const processData = ref([])
    watch(
      () => InspectTasksDetailsForm.projectId,
      newValue => {
        processData.value = []
        if (newValue) {
          getProcessData()
        } else {
          InspectTasksDetailsForm.process.definitionId = ''
        }
      }
    )
    const getProcessData = () => {
      let params = {
        companyId: '',
        projectId: InspectTasksDetailsForm.projectId,
        businessType: 'inspect_task',
        pageIndex: 1,
        pageSize: 500
      }
      dispatch('fetchProjectProcessPage', params).then(res => {
        if (res.code === 200) {
          processData.value = res.data.records
          const item = processData.value.find(
            d => d.definitionId === InspectTasksDetailsForm.process.definitionId
          )
          if (!item) {
            let processDataValue = processData.value[0] || {}
            InspectTasksDetailsForm.process.definitionId = processDataValue.definitionId || ''
            InspectTasksDetailsForm.process.processKey = processDataValue.processKey || ''
            InspectTasksDetailsForm.process.businessType = processDataValue.businessType || ''
            InspectTasksDetailsForm.process.processName = processDataValue.processName || ''
          }
        }
      })
    }
    const definitionChange = value => {
      if (value) {
        const item = processData.value.find(d => d.definitionId === value)
        InspectTasksDetailsForm.process.processKey = (item && item.processKey) || ''
        InspectTasksDetailsForm.process.businessType = (item && item.businessType) || ''
        InspectTasksDetailsForm.process.processName = (item && item.processName) || ''
      } else {
        InspectTasksDetailsForm.process.processKey = ''
        InspectTasksDetailsForm.process.businessType = ''
        InspectTasksDetailsForm.process.processName = ''
      }
    }

    const activeName = ref('detail')
    let pecList = ref([])
    let pointList = ref([])

    /* 点位打卡地图 开始 **********************************/
    let pointCheckMap = null
    let amapInstance = null // 缓存 AMap 实例，避免重复 load

    // 加载 AMap（只加载一次）
    const ensureAMap = async () => {
      if (amapInstance) return amapInstance
      // 如果全局已存在（其他页面已加载过）
      if (window.AMap) {
        amapInstance = window.AMap
        return amapInstance
      }
      amapInstance = await AMapLoader.load({
        key: '8fb96b5c1d0841623c6a9aa5cde6ecee',
        version: '1.4.15',
        plugins: ['AMap.Scale', 'AMap.Driving']
      })
      return amapInstance
    }

    // 加载驾车路线规划插件（兼容 window.AMap 已存在的场景）
    const loadDrivingPlugin = AMap => {
      return new Promise(resolve => {
        if (AMap.Driving) {
          resolve()
          return
        }
        AMap.plugin('AMap.Driving', () => resolve())
      })
    }

    // 提取驾车路线的坐标点串
    const extractDrivingPath = route => {
      let path = []
      if (route && Array.isArray(route.steps)) {
        route.steps.forEach(step => {
          if (Array.isArray(step.path)) {
            path = path.concat(step.path)
          }
        })
      }
      return path
    }

    // 沿道路绘制驾车轨迹线（按打卡时间串联）
    const drawDrivingTrack = async (AMap, lnglatList) => {
      const points = lnglatList.map(p => new AMap.LngLat(p[0], p[1]))
      // 高德驾车规划每段最多支持16个途经点（即每段最多18个点），超出需分段拼接
      const MAX_SEG_POINTS = 18
      const driving = new AMap.Driving({
        autoFitView: false,
        hideMarkers: true
      })

      // 规划单段驾车路线，失败时降级为直线
      const searchSegment = segPoints => {
        return new Promise(resolve => {
          const origin = segPoints[0]
          const destination = segPoints[segPoints.length - 1]
          const waypoints = segPoints.slice(1, -1)
          driving.search(origin, destination, { waypoints }, (status, result) => {
            if (status === 'complete' && result && result.routes && result.routes.length > 0) {
              const segPath = extractDrivingPath(result.routes[0])
              if (segPath.length > 0) {
                resolve(segPath)
                return
              }
            }
            // 该段规划失败，降级为直线连接
            resolve(segPoints)
          })
        })
      }

      const fullPath = []
      for (let i = 0; i < points.length - 1; i += MAX_SEG_POINTS - 1) {
        const segPoints = points.slice(i, i + MAX_SEG_POINTS)
        const segPath = await searchSegment(segPoints)
        fullPath.push(...segPath)
      }

      if (fullPath.length >= 2) {
        pointCheckMap.add(
          new AMap.Polyline({
            path: fullPath,
            strokeColor: '#00BD00',
            strokeWeight: 4,
            strokeOpacity: 0.8,
            strokeStyle: 'solid',
            lineJoin: 'round',
            lineCap: 'round',
            showDir: true,
            zIndex: 50
          })
        )
      }
    }

    // 初始化点位打卡地图
    const initPointCheckMap = async () => {
      await nextTick()
      // 延迟一帧确保 v-else-if 的 DOM 已完全渲染
      await new Promise(resolve => setTimeout(resolve, 100))

      const mapContainer = document.getElementById('pointCheckMap')
      if (!mapContainer) {
        console.warn('[pointCheckMap] 地图容器不存在')
        return
      }
      // 确保容器有尺寸
      if (mapContainer.offsetHeight === 0) {
        console.warn('[pointCheckMap] 地图容器高度为0')
        return
      }

      let AMap
      try {
        AMap = await ensureAMap()
      } catch (e) {
        console.error('[pointCheckMap] AMap加载失败', e)
        return
      }

      // 销毁旧地图
      if (pointCheckMap) {
        pointCheckMap.destroy()
        pointCheckMap = null
      }

      pointCheckMap = new AMap.Map('pointCheckMap', {
        zoom: 13,
        resizeEnable: true
      })
      pointCheckMap.addControl(new AMap.Scale())

      // 获取点位坐标：优先使用原始配置的点位坐标(pointLongitude/pointLatitude)，
      // 打卡坐标(longitude/latitude)作为回退，保证未打卡的点位也能显示
      const getPointLngLat = item => {
        let lng = parseFloat(item.pointLongitude)
        let lat = parseFloat(item.pointLatitude)
        if (isNaN(lng) || isNaN(lat) || (lng === 0 && lat === 0)) {
          lng = parseFloat(item.longitude)
          lat = parseFloat(item.latitude)
        }
        if (isNaN(lng) || isNaN(lat) || (lng === 0 && lat === 0)) {
          return null
        }
        return [lng, lat]
      }

      // 过滤出有有效经纬度的点位
      const validPoints = (pointList.value || [])
        .map(item => ({ ...item, lnglat: getPointLngLat(item) }))
        .filter(item => item.lnglat)

      console.log('[pointCheckMap] 有效点位数量:', validPoints.length, validPoints)

      if (validPoints.length === 0) {
        return
      }

      // 按打卡时间排序（有打卡时间的在前，无打卡时间的按规划排序在后）
      const sortedPoints = [...validPoints].sort((a, b) => {
        if (a.checkTime && b.checkTime) {
          return new Date(a.checkTime) - new Date(b.checkTime)
        }
        if (a.checkTime) return -1
        if (b.checkTime) return 1
        return (a.orderIndex || 0) - (b.orderIndex || 0)
      })

      // 点位状态颜色
      const getStatusColor = item => {
        if (item.dataStatus === '1') return '#00b42a'
        if (item.dataStatus === '2') return '#f53f3f'
        return '#86909c'
      }

      const allOverlays = []
      const polylinePath = []

      // 统一信息窗
      const infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -30),
        closeWhenClickMap: true
      })

      sortedPoints.forEach((item, index) => {
        const [lng, lat] = item.lnglat
        const position = new AMap.LngLat(lng, lat)
        const color = getStatusColor(item)
        const seq = index + 1
        // 打卡上报的坐标
        const checkLng = parseFloat(item.longitude)
        const checkLat = parseFloat(item.latitude)
        const hasCheckLnglat =
          !isNaN(checkLng) && !isNaN(checkLat) && checkLng !== 0 && checkLat !== 0

        // 1. 用 CircleMarker 画圆点（已打卡蓝色，未打卡灰色）
        const planMarkerColor = item.checkTime ? '#165dff' : '#86909c'
        const circleMarker = new AMap.CircleMarker({
          center: position,
          radius: 18,
          fillColor: planMarkerColor,
          fillOpacity: 0.9,
          strokeColor: '#fff',
          strokeWeight: 2,
          strokeOpacity: 1,
          cursor: 'pointer',
          zIndex: 100
        })

        // 2. 用 Text 标记显示序号
        const textMarker = new AMap.Text({
          text: String(seq),
          position,
          anchor: 'center',
          cursor: 'pointer',
          style: {
            background: 'transparent',
            border: 'none',
            color: '#fff',
            'font-size': '14px',
            'font-weight': 'bold',
            padding: '0',
            'text-align': 'center'
          }
        })

        // 3. 用 Marker 显示点位名称（标签）
        const labelMarker = new AMap.Marker({
          position,
          content: ' ',
          offset: new AMap.Pixel(0, -28),
          label: {
            content: `<span class="point-check-label">${item.pointName || '点位' + seq}</span>`,
            direction: 'top'
          }
        })

        // 信息窗内容（区分：配置点位 / 实际打卡点）
        const statusText =
          item.dataStatus === '1' ? '正常打卡' : item.dataStatus === '2' ? '漏检' : '未巡检'
        // 两点偏差距离（米）
        let offsetDistance = ''
        if (hasCheckLnglat && (checkLng !== lng || checkLat !== lat)) {
          try {
            const d = AMap.GeometryUtil.distance(
              new AMap.LngLat(lng, lat),
              new AMap.LngLat(checkLng, checkLat)
            )
            offsetDistance = d >= 1000 ? `${(d / 1000).toFixed(2)}km` : `${Math.round(d)}m`
          } catch (e) {
            offsetDistance = ''
          }
        }

        // 弹窗：配置的打卡点（大圆点/序号）
        const planInfoContent = `<div class="point-check-info-window">
          <div class="info-title">${
            item.pointName || '未命名点位'
          }<span class="info-tag info-tag-plan">配置点位</span></div>
          <div class="info-row"><span>点位类型：</span><span>巡检计划配置的点位</span></div>
          <div class="info-row"><span>排序：</span><span>${item.orderIndex || seq}</span></div>
          <div class="info-row"><span>状态：</span><span style="color:${color};font-weight:bold;">${statusText}</span></div>
          <div class="info-row"><span>配置坐标：</span><span>${lng.toFixed(6)}, ${lat.toFixed(
          6
        )}</span></div>
          ${
            hasCheckLnglat
              ? `<div class="info-row"><span>打卡时间：</span><span>${
                  item.checkTime || '未打卡'
                }</span></div>${
                  offsetDistance
                    ? `<div class="info-row"><span>偏差距离：</span><span style="color:#165dff;font-weight:bold;">${offsetDistance}</span></div>`
                    : ''
                }`
              : ''
          }
        </div>`

        // 弹窗：实际打卡点（蓝点）
        const checkInfoContent = `<div class="point-check-info-window">
          <div class="info-title">${
            item.pointName || '未命名点位'
          }<span class="info-tag info-tag-check">实际打卡点</span></div>
          <div class="info-row"><span>点位类型：</span><span>打卡上报的位置</span></div>
          <div class="info-row"><span>打卡时间：</span><span>${item.checkTime || '-'}</span></div>
          <div class="info-row"><span>状态：</span><span style="color:${color};font-weight:bold;">${statusText}</span></div>
          <div class="info-row"><span>打卡坐标：</span><span>${checkLng.toFixed(
            6
          )}, ${checkLat.toFixed(6)}</span></div>
          ${
            offsetDistance
              ? `<div class="info-row"><span>距配置点位：</span><span style="color:#165dff;font-weight:bold;">${offsetDistance}</span></div>`
              : ''
          }
        </div>`

        // 点击大圆点/序号 → 配置点位弹窗
        const openInfo = () => {
          infoWindow.setContent(planInfoContent)
          infoWindow.open(pointCheckMap, position)
        }
        circleMarker.on('click', openInfo)
        textMarker.on('click', openInfo)

        allOverlays.push(circleMarker, textMarker, labelMarker)

        // 4. 已打卡且打卡位置与规划点位不同时，额外标出实际打卡位置
        if (hasCheckLnglat && (checkLng !== lng || checkLat !== lat)) {
          const checkPosition = new AMap.LngLat(checkLng, checkLat)
          // 实际打卡位置小圆点（绿色）
          const checkCircle = new AMap.CircleMarker({
            center: checkPosition,
            radius: 8,
            fillColor: '#00BD00',
            fillOpacity: 1,
            strokeColor: '#fff',
            strokeWeight: 2,
            strokeOpacity: 1,
            cursor: 'pointer',
            zIndex: 110
          })
          // 规划点位 → 实际打卡位置 偏移虚线
          const offsetLine = new AMap.Polyline({
            path: [position, checkPosition],
            strokeColor: '#165dff',
            strokeWeight: 2,
            strokeOpacity: 0.7,
            strokeStyle: 'dashed',
            zIndex: 60
          })
          // 点击蓝点 → 实际打卡点弹窗
          checkCircle.on('click', () => {
            infoWindow.setContent(checkInfoContent)
            infoWindow.open(pointCheckMap, checkPosition)
          })
          allOverlays.push(checkCircle, offsetLine)
        }

        // 只连接有实际打卡位置的点位，无打卡坐标的不参与连线
        if (item.checkTime && hasCheckLnglat) {
          polylinePath.push([checkLng, checkLat])
        }
      })

      // 将所有覆盖物添加到地图
      pointCheckMap.add(allOverlays)

      // 绘制驾车轨迹线（按打卡时间串联，沿实际道路行驶路线）
      if (polylinePath.length >= 2) {
        await loadDrivingPlugin(AMap)
        await drawDrivingTrack(AMap, polylinePath)
      }

      // 自适应视野
      pointCheckMap.setFitView(allOverlays, false, [80, 80, 80, 80])
    }

    // 监听 activeName 变化，切换到 pointCheck 时初始化地图
    watch(activeName, newVal => {
      if (newVal === 'pointCheck') {
        nextTick(() => {
          initPointCheckMap()
        })
      }
    })
    /* 点位打卡地图 结束 **********************************/

    const getPointStatusText = row => {
      if (row.dataStatus === '1') return '正常打卡'
      if (row.dataStatus === '2') return '漏检'
      return '未巡检'
    }

    const getPointStatusClass = row => {
      if (row.dataStatus === '1') return 'green-text'
      if (row.dataStatus === '2') return 'red-text'
      return 'gray-text'
    }

    const getPointRemark = row => {
      if (row.checkTime) return '无'
      if (row.dataStatus === '2') return '未抵达现场'
      return '未执行巡检'
    }

    const pointStats = computed(() => {
      const list = pointList.value || []
      return {
        normal: list.filter(d => d.checkTime).length,
        missed: list.filter(d => !d.checkTime && d.dataStatus === '2').length,
        notInspected: list.filter(d => !d.checkTime && d.dataStatus !== '2').length
      }
    })

    const getPecListHandle = () => {
      dispatch('fetchListByErrorIdPcs', { errorId: inspectTaskId }).then(res => {
        if (res.code === 200) {
          pecList.value = res.data
          let recordList = res.data
          pecList.value = recordList.map(d => {
            const endItem = d.recordList.find(k => k.recordType === 'END')
            const startItem = d.recordList.find(k => k.recordType === 'START')
            if (endItem) {
              d.recordType = 'END'
              d.endAddress = endItem.addr
              d.actualMileage = endItem.actualMileage
              d.endCreateTime = endItem.createTime
            } else {
              d.recordType = 'START'
            }
            d.createTime = (startItem && startItem.createTime) || ''
            d.startFileList = (startItem && startItem.fileList) || []
            d.endFileList = (endItem && endItem.fileList) || []
            return d
          })
        }
      })
    }

    onMounted(async () => {
      await updateInfoHandle()
      await getPecListHandle()
    })
    return {
      clickDownloadExcel,
      InspectTasksDetailsForm,
      clickCancelFultServiceCenter,
      tabberHeight,
      inspectOrderStatusImg,
      isAudit,
      isAmibaManager,
      btnCode,
      btnName,
      processCof,
      customButtons,
      formDisabled,
      showDistributeDialog,
      deviceErrorLogsByError,
      distributeRef,
      completedType,
      showCompletedDialog,
      completedRef,
      sourData,
      showSubmitDialog,
      submitRef,
      submitType,
      getProcessConf,
      getDeviceErrorLogsByError,
      clickReportOrder,
      successDistributedDialog,
      closeDistributedDialog,
      successCompletedDialog,
      closeCompletedDialog,
      successSubmitDialog,
      closeSubmitDialog,
      viewFromHandle,
      showSubmitTaskDialog,
      submitTaskRef,
      submitTaskType,
      inspectTaskId,
      successSubmitTaskDialog,
      closeSubmitTaskDialog,
      processData,
      definitionChange,
      getProcessData,
      activeName,
      getPecListHandle,
      pecList,
      pointList,
      getPointStatusText,
      getPointStatusClass,
      getPointRemark,
      pointStats,
      FILEPREVIEWURL,
      BASEURL
    }
  }
}
</script>

<style lang="scss">
.inspect-tasks-details {
  position: relative;
  &-globalTitle {
    position: relative;
    z-index: 1;
    &-image {
      position: absolute;
      width: 100px;
      top: -50px;
      left: 150px;
    }
  }
}
.btn-box {
  display: flex;
  align-items: center;
  padding-left: 450px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #fff;
  border-top: 1px dashed #ebeef5;
}
.content-box {
  padding-bottom: 60px;
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
}
.green-text {
  color: #00b42a;
  font-weight: bold;
}
.red-text {
  color: #f53f3f;
  font-weight: bold;
}
.gray-text {
  color: #888;
}

/* 点位打卡地图样式 */
.point-check-map-wrapper {
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}
.point-check-map {
  width: 100%;
  height: 500px;
}
/* 地图图例 */
.point-check-map-legend {
  position: absolute;
  right: 10px;
  bottom: 10px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 10px 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 6px;
  .legend-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
  }
  .legend-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 6px;
    border: 2px solid #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
  }
  .legend-dot-plan {
    background-color: #165dff;
  }
  .legend-dot-not {
    background-color: #86909c;
  }
  .legend-dot-check {
    background-color: #00bd00;
  }
  .legend-line {
    display: inline-block;
    width: 20px;
    height: 3px;
    margin-right: 6px;
    background-color: #165dff;
    border-radius: 2px;
  }
}
/* 地图标点样式 */
.point-check-marker {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  span {
    line-height: 1;
  }
}
/* 点位名称标签样式 */
.amap-marker-label {
  border: none !important;
  background: rgba(0, 21, 40, 0.8) !important;
  color: #fff !important;
  padding: 3px 8px !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  white-space: nowrap !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3) !important;
}
/* Text 标记样式覆盖 */
.amap-text {
  pointer-events: auto;
}
/* 信息窗样式 */
.point-check-info-window {
  padding: 6px 4px;
  min-width: 200px;
  .info-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
  }
  .info-tag {
    display: inline-block;
    font-size: 12px;
    font-weight: normal;
    padding: 1px 8px;
    border-radius: 3px;
    margin-left: 8px;
    color: #fff;
    white-space: nowrap;
  }
  .info-tag-plan {
    background-color: #165dff;
  }
  .info-tag-check {
    background-color: #00bd00;
  }
  .info-row {
    font-size: 13px;
    color: #666;
    line-height: 1.8;
    display: flex;
    span:first-child {
      color: #999;
      white-space: nowrap;
    }
  }
}
</style>